<template>
  <div class="etapas configuracoes" :value="idPublicacao">
    <h3 class="titlePage">Logo</h3>
    <div class="row">
      <div class="col-sm-12 m-3">
        <div v-if="controlePage.urllogo" style="max-width: 180px" class="text-center">
          <div><img :src="controlePage.urllogo" style="width: 100%" alt="logo" /></div>
          <button class="btn btn-primary mt-3" @click="deletaArquivo">Excluir</button>
        </div>
        <fcc-galeria
          v-else
          cod-arq-cad="CDN"
          :extArqPermitido="['jpeg', 'jpg', 'png']"
          :id-externo="idPublicacao + spi"
          exibe-imagens
          @success="logoAlterado"
          :arqMaxQtde="1"
        ></fcc-galeria>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    idPublicacao: Number,
    spi: String,
    controlePage: Object
  },
  methods: {
    deletaArquivo() {
      this.callConfirm('Deseja realmente excluir o logo ?', '').then((res) => {
        if (res.value) {
          this.carregaTexto(this.codeMensagem('C02'))
          this.DeleteArquivoGenerico('CDN', this.idPublicacao + this.spi)
          setTimeout(() => {
            this.logoAlterado(null)
          }, 1000)
        }
      })
    },
    logoAlterado(logo) {
      this.controlePage.urllogo = logo != null ? logo.arqurl : ''
      this.$emit('alteraPublicacao', this.controlePage)
    }
  }
}
</script>
